export default "__VITE_ASSET__BPSb6L8r__"